import { $_app_server } from '@/_helpers'
//import { userService } from '@/_services'

export const caseService = {
  add,
  addSession,

  list,
  listWithEventdate,
  listByStatus,
  show,
  sendChannels,
  caseStatuses,
  caseTableTypes,

  listCategories,
  updateCategories,
  delCategory,

  listGroupCategory,
  addGroupCategory,
  showGroupCategory,
  delGroupCategory,
  searchByNumber,
  showWithMemberAndSession,

  sendRecord,
  genCodes
}

function add (caseForm) {
  return $_app_server.post("cases/add", caseForm).then(response => response.data)
}
function addSession (caseSession) {
  return $_app_server.post("casesession/add", caseSession).then(response => response.data)
}

function listWithEventdate () {
  return $_app_server.get("cases/eventdate").then(response => response.data)
}

function list () {
  return $_app_server.get("cases").then(response => response.data)
}

function listByStatus (status) {
  return $_app_server.get(`cases/status/${status}`).then(response => response.data)
}

function show (caseId) {
  return $_app_server.get("/cases/" + caseId)
  .then(response => response.data)
}

function sendChannels () {
  return $_app_server.get("sendchannels")
  .then(response => response.data)
}

function caseStatuses () {
  return $_app_server.get("casestatuses").then(response => response.data)
}

function caseTableTypes () {
  return $_app_server.get("casetabletypes").then(response => response.data)
}

// == CATEGORY ==

function listCategories () {
  return $_app_server.get("categories")
  .then(response => response.data)
}

function updateCategories (category) {
  return $_app_server.put('categories/add', category).then(response => response.data)
}

function delCategory(categoryId) {
  return $_app_server.delete("/categories/" + categoryId + "/del")
}


// == GROUP CATEGORY ==

function listGroupCategory () {
  return $_app_server.get('categories/group').then(response => response.data)
}

function addGroupCategory(group) {
  return $_app_server.put("/categories/add/group", group).then(response => response.data)
}

function showGroupCategory(groupId) {
  return $_app_server.get("/categories/group/" + groupId).then(response => response.data)
}

function delGroupCategory(groupId) {
  return $_app_server.delete("/categories/group/" + groupId + "/del")
}

function searchByNumber (number) {
  return $_app_server.post("/cases/number", number).then(response => response.data)
}

function showWithMemberAndSession (caseId) {
  return $_app_server.get("/case/" + caseId)
  .then(response => response.data)
}

// == TRANSCRIPT ==

function sendRecord (sessionId, form) {
  return $_app_server.post("/file/sessionpart/" + sessionId, form).then(response => response.data)
}

function genCodes (caseId) {
  return $_app_server.get("/case/gencodes/" + caseId)
  .then(response => response.data)
}

